import React from "react";
import "./DesktopRightMenu.css";

interface IDesktopRightMenuProps{

}

export const DesktopRightMenu = ({}: IDesktopRightMenuProps)=>{
    return <div className="desktop_left">
        <div className="desktop_top">
            <div className="desktop_menu_item desktop_menu_item--clients">
                All clients
            </div>
            <div className="desktop_menu_item desktop_menu_item--schedule">
                Schedule
            </div>
            <div className="desktop_menu_item desktop_menu_item--tasks">
                Tasks
            </div>
        </div>
        <div className="desktop_bottom">
            <div className="desktop_menu_item">
                Read more
            </div>
            <div className="desktop_menu_item desktop_menu_item--blog">
                Blog
            </div>
            <div className="desktop_menu_item desktop_menu_item--settings">
                Settings
            </div>
        </div>
    </div>
}
